
import * as corporateAction from './action';
const initialState = {
    globalSearchResult: [],
    searchParam: "",
    searchText: "",
    countryName: "",
    countryCode: "",
    selectedCounterParty: [],
    corporateColor: '',
    corporateColorFailure: [],
    globalSearchBoxShow: true
}
const corporateReducer = (state = initialState, action) => {
    switch (action.type) {

        case corporateAction.GLOBAL_COUNTERPARTY_SEARCH_SUCCESS:
            return state = {
                ...state,
                globalSearchResult: action.data
            }
        case corporateAction.GLOBAL_COUNTERPARTY_SEARCH_FAILURE:
            return state = {
                ...state,
                globalSearchResult: action
            }
        case corporateAction.ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_SUCCESS:
            return state = {
                ...state,
                globalSearchResult: action.data
            }
        case corporateAction.ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_FAILURE:
            return state = {
                ...state,
                globalSearchResult: action
            }
        case corporateAction.SEARCH_PARAMETER:
            return state = {
                ...state,
                searchParam: action.search
            }
        case corporateAction.SEARCH_TEXT:
            return state = {
                ...state,
                searchText: action.search
            }
        case corporateAction.COUNTRY_NAME:
            return state = {
                ...state,
                countryName: action.countryName
            }
        case corporateAction.COUNTRY_CODE:
            return state = {
                ...state,
                countryCode: action.countryCode
            }
        case corporateAction.VIEW_SELECTED_COUNTERPARTY_SUCCESS:
            return state = {
                ...state,
                selectedCounterParty: action.data
            }
        case corporateAction.VIEW_SELECTED_COUNTERPARTY_FAILURE:
            return state = {
                ...state,
                selectedCounterParty: action
            }
        case corporateAction.SET_CORPORATE_COLOR_SUCCESS:
            return state = {
                ...state,
                corporateColor: action.data
            }
        case corporateAction.SET_CORPORATE_COLOR_FAILURE:
            return state = {
                ...state,
                corporateColorFailure: action.data
            }
        case corporateAction.SET_GLOBAL_SEARCHBOX_SHOW:
            return state = {
                ...state,
                globalSearchBoxShow: action.data
            }
        default: return state
    }
}

export default corporateReducer; 